import React from 'react';

function Challenge() {
  return (
    <section className="section-padding bord-thin-bottom">
      <div className="container">
        <div className="row">
          <div className="col-lg-5">
            <h2 className="mb-50">
              The <br /> Challenge
            </h2>
          </div>
          <div className="col-lg-7">
            <div className="text">
              <h5 className="line-height-40">
              The Aroma Snacks Cafe project presents several unique challenges that must be carefully navigated to ensure success. First, establishing a strong brand identity in a saturated market is a significant hurdle, especially in an industry where consumer preferences are diverse and rapidly changing.
              </h5>
            </div>
            {/* <div className="accordion bord mt-100">
              <div
                className="item active mb-15 wow fadeInUp"
                data-wow-delay=".1s"
              >
                <div className="title">
                  <h6>Designing Content With AI Power</h6>
                  <span className="ico ti-plus"></span>
                </div>
                <div className="accordion-info">
                  <p className="">
                    Taken possession of my entire soul, like these sweet
                    mornings of spring which i enjoy with my whole.
                  </p>
                </div>
              </div>

              <div className="item mb-15 wow fadeInUp" data-wow-delay=".3s">
                <div className="title">
                  <h6>Talented, Professional & Expert Team</h6>
                  <span className="ico ti-plus"></span>
                </div>
                <div className="accordion-info">
                  <p className="">
                    Taken possession of my entire soul, like these sweet
                    mornings of spring which i enjoy with my whole.
                  </p>
                </div>
              </div>

              <div className="item wow fadeInUp" data-wow-delay=".5s">
                <div className="title">
                  <h6>We Build and Activate Brands</h6>
                  <span className="ico ti-plus"></span>
                </div>
                <div className="accordion-info">
                  <p className="">
                    Taken possession of my entire soul, like these sweet
                    mornings of spring which i enjoy with my whole.
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Challenge;
